class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.country-list-wrap'),
      body: document.querySelector('body'),
      header: document.querySelector('#shopify-section-header-new')
    };
    this.elements.button && this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button && this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
    this.hidePanel();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    this.elements.body.classList.toggle('country-list-active');
    let isDefaultTransparentHeader = this.elements.header.querySelector('[data-header]').dataset.transparent === 'true' ? true : false;
    isDefaultTransparentHeader ? this.elements.header.classList.toggle('temporarily-hide-transparent') : null;
  }

  closeSelector(event) {
    const isChild =
    this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
    this.elements.header.classList.contains('temporarily-hide-transparent') ? this.elements.header.classList.remove('temporarily-hide-transparent') : null;
    if (!event.relatedTarget || !isChild) {
      this.hidePanel();
    }
    if (this.elements.body.classList.contains('country-list-active')) {
      this.elements.body.classList.remove('country-list-active');
    }
  }
}

customElements.define('localization-form', LocalizationForm);
